<template>
  <div class="shop_wrapper">
    <div class="container">
      <div class="accoun_dashboard">
        <div class="row">
          <div class="col-xl-2 col-lg-3 col-md-12 col-sm-12">
            <div class="dashboard_tab_button mt-4">
              <ul role="tablist" class="nav flex-column dashboard-list">
                <li><router-link :to="{name: 'user-dashboard', params: { language: getLocale } }" class="nav-link">{{ $t('Dashboard') }}</router-link></li>
                <li v-if=" getFavlistsVisibility "><router-link :to="{name: 'user-favlists', params: { language: getLocale }}" class="nav-link">{{ $t('Listas de favoritos') }}</router-link></li>
                <li v-if=" getFavlistsVisibility "><router-link :to="{name: 'user-help', params: { language: getLocale }}" class="nav-link">{{ $t('Ayuda') }}</router-link></li>
                <!-- <li><router-link :to="{name: 'user-orders'}" class="nav-link">Estado de pedidos</router-link></li> -->
                <!-- <li><router-link :to="{name: 'user-account'}" class="nav-link">Perfil</router-link></li> -->
                <!--<li><router-link :to="{name: 'user-change-password'}" class="nav-link">Cambiar contraseña</router-link></li>-->
                <!-- <li><a href="#" class="nav-link">Cerrar Sesión</a></li> -->
              </ul>
              <small class="d-block text-center text-muted">App version: v.{{ getAppVersion }}</small>
            </div>
          </div>

          <div class="col-xl-10 col-lg-9 col-md-12 col-sm-12">    
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n>
  {
    "es": {
      "Dashboard": "Dashboard",
      "Listas de favoritos": "Listas de favoritos",
      "Ayuda": "Ayuda"
    },
    "en": {
      "Dashboard": "Dashboard",
      "Listas de favoritos": "Favorites lists",
      "Ayuda": "Help"
    }
  }
</i18n>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data: () => {
      return {
        
      }
    },
    computed: {	
      ...mapGetters( ['getLocale', 'getFavlistsVisibility', 'getAppVersion'])
    }
  }
</script>

<style type="text/css">
  .dashboard_tab_button li a{ 
    width: 100%;
  }
  .dashboard-list .active{ color: #FFF !important; }
</style>